import { z } from 'zod';
import { EmailValidation, PasswordValidation } from 'shared/validation/validationTemplates';

export const LoginFormValidation = EmailValidation.and(PasswordValidation);

export type TLoginFormType = z.infer<typeof LoginFormValidation>;
